import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2ReservationDateNoteKeys } from './use-v2-reservation-datenote-find-query'
import { v2ReservationDateNoteDateKeys } from './use-v2-reservation-datenote-find-date-query'

type UpdateReservationDateNoteBody = Parameters<typeof apiClient.v2.apiV2ReservationdatenoteElUpdate>[0]

const updateReservationDateNote = async (body: UpdateReservationDateNoteBody) => {
  const { data } = await apiClient.v2.apiV2ReservationdatenoteElUpdate(body)
  return checkApiResponse(data)
}

export const useV2ReservationDateNoteUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateReservationDateNoteBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: updateReservationDateNote,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2ReservationDateNoteKeys.all })
        queryClient.invalidateQueries({ queryKey: v2ReservationDateNoteDateKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
